var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 2.908h10.667c.733 0 1.333.6 1.333 1.334v8c0 .733-.6 1.333-1.333 1.333H2.667c-.733 0-1.333-.6-1.333-1.333v-8c0-.734.6-1.334 1.333-1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 4.241L8.001 8.908 1.334 4.24"
  }))));
}
export default __webpack_public_path__ + "static/media/icon_email.5572a086.svg";
export { SvgIconEmail as ReactComponent };